'use strict';

/** Import frontoffice_app */
import '../frontoffice_app';

/** Import FilterLinks */
import FilterLinks from '../../../shared/utility/filter_links/filter_links';

/** Import Pagination */
import Pagination from '../../../shared/pagination/pagination';

/** Import Cart class */
import Cart from '../../../shared/cart/cart'

/** @const RIM_SEARCH */
const RIM_SEARCH = 'rims/search';

/**
 * @class RimsSearchHandler
 */
class RimsSearchHandler
{
    /**
     * @constructor
     */
    constructor ()
    {
        this._listenLinkByFilters();

        new Pagination({
            url: 'rim/pagination',
            activeStatistic: true,
            additionalFilters: [
                { selector: '#frontoffice-filter-rims-search', event: 'keyup', key: 'search', default: null },
                { selector: '#frontoffice-filter-rims-diameters', event: 'change', key: 'diameters', default: [] },
                { selector: '#frontoffice-filter-rims-widths', event: 'change', key: 'widths', default: [] },
                { selector: '#frontoffice-filter-rims-offset', event: 'change', key: 'offsets', default: [] },
                { selector: '#frontoffice-filter-rims-span', event: 'change', key: 'spans', default: [] },
                { selector: '#frontoffice-filter-rims-hub', event: 'change', key: 'hubs', default: [] },
                { selector: '#price-range-input-button', event: 'click', key: { from: 'priceLower', to: 'priceUpper', range: '#price-range-input' }, default: null, type: 'range' }
            ],
            responseCallbacks: [ this._responseCallback ]
        });
    }

    /**
     * @private
     */
    _listenLinkByFilters ()
    {
        let that = this;
        $('#frontoffice-filter-rims-widths').on('change', (e) =>
        {
            let filters = FilterLinks.getFiltersCollectionFromLink();
            filters['širina'] = $(e.target).val();
            that.constructor._generateLinkFromFilters(filters)
        });

        $('#frontoffice-filter-rims-diameters').on('change', (e) =>
        {
            let filters = FilterLinks.getFiltersCollectionFromLink();
            filters['prečnik'] = $(e.target).val();
            that.constructor._generateLinkFromFilters(filters)
        });

        $('#frontoffice-filter-rims-offset').on('change', (e) =>
        {
            let filters = FilterLinks.getFiltersCollectionFromLink();
            filters['offset'] = $(e.target).val();
            that.constructor._generateLinkFromFilters(filters)
        });

        $('#frontoffice-filter-rims-span').on('change', (e) =>
        {
            let filters = FilterLinks.getFiltersCollectionFromLink();
            filters['raspon'] = $(e.target).val();
            that.constructor._generateLinkFromFilters(filters)
        });

        $('#frontoffice-filter-rims-hub').on('change', (e) =>
        {
            let filters = FilterLinks.getFiltersCollectionFromLink();
            filters['centralna_rupa'] = $(e.target).val();
            that.constructor._generateLinkFromFilters(filters)
        });
    }

    /**
     * @param response
     * @private
     */
    _responseCallback (response)
    {
        $('.add_to_cart').on('click', (e) =>
        {
            e.preventDefault();
            Cart.addToCart($(e.target).data('cartitem'));
        })
    }

    /**
     * @param filtersArray
     * @private
     */
    static _generateLinkFromFilters (filtersArray)
    {
        FilterLinks.generateLinkFromFilters(filtersArray, RIM_SEARCH);
    }
}

/** Start TiresSearchHandler */
$(document).ready(() => { new RimsSearchHandler(); });


// WEBPACK FOOTER //
// ./assets/js/components/frontoffice/pages/rims.js